<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useVersionCheck } from '@/composables/useVersionCheck';

const { t } = useI18n();
const { updateAvailable, reloading, reload } = useVersionCheck();
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-2"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-2"
  >
    <div v-if="updateAvailable" role="status" aria-live="polite" class="pointer-events-auto max-w-sm rounded-lg border border-blue-200 bg-blue-50 shadow-lg">
      <div class="flex items-start gap-3 p-4">
        <div class="flex-shrink-0 mt-0.5">
          <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-semibold text-blue-900">
            {{ t('update.available') }}
          </p>
          <p class="mt-1 text-sm text-blue-700">
            {{ t('update.description') }}
          </p>
          <button
            type="button"
            :disabled="reloading"
            class="mt-3 inline-flex items-center px-3 py-1.5 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-medium rounded-md transition-colors"
            @click="reload"
          >
            {{ reloading ? t('update.reloading') : t('update.reloadNow') }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
